/**
 * Feature Flags API Client (web)
 *
 * Mirrors `apps/WunderGuide/api/featureFlagsApi.ts`. Wraps
 * `@wg/api/feature-flags` with the web's authenticated httpClient so
 * `getFlags()` returns the same resolved-flag map RN sees.
 */

import { createFeatureFlagsApi } from '@wg/api/feature-flags';
import { httpClient } from '../http';

export type { ResolvedFlags } from '@wg/api/feature-flags';

const api = createFeatureFlagsApi(httpClient);

export const getFlags = api.getFlags;

export const featureFlagsApi = api;
export default api;
